import React from 'react'
import { useSelector } from 'react-redux';
import { useThemeColor } from '../../../hooks/useThemeColor';

const Slider = ({ label, value, onChange, disabled = false }) => {
  const { data, loading } = useSelector((state) => state.admin);
  const { primaryColor } = useThemeColor();

  const isAdmin =
    data?.user_role === "SUPER_ADMIN" || data?.user_role === "ADMIN";
  
  const isDisabled = disabled || !isAdmin;
  
  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <span className="text-sm text-gray-500">{value}</span>
      </div>
      <div className="relative">
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={value}
          onChange={onChange}
          disabled={isDisabled}
        className={`${isDisabled ? 'opacity-50 cursor-not-allowed' : ''} w-full h-2 rounded-lg appearance-none cursor-pointer 
            [&::-webkit-slider-thumb]:appearance-none 
            [&::-webkit-slider-thumb]:h-4 
            [&::-webkit-slider-thumb]:w-4 
            [&::-webkit-slider-thumb]:rounded-full 
            [&::-webkit-slider-thumb]:bg-white 
            [&::-webkit-slider-thumb]:border-2
            [&::-webkit-slider-thumb]:border-white
            [&::-webkit-slider-thumb]:shadow-md
            [&::-webkit-slider-thumb]:cursor-pointer
            [&::-webkit-slider-thumb]:relative
            [&::-webkit-slider-thumb]:z-[2]
            [&::-moz-range-thumb]:h-4 
            [&::-moz-range-thumb]:w-4 
            [&::-moz-range-thumb]:rounded-full 
            [&::-moz-range-thumb]:bg-white 
            [&::-moz-range-thumb]:border-2
            [&::-moz-range-thumb]:border-white
            [&::-moz-range-thumb]:shadow-md
            [&::-moz-range-thumb]:cursor-pointer
            [&::-moz-range-thumb]:relative
            [&::-moz-range-thumb]:z-[2]`}
          style={{
            background: `linear-gradient(to right, ${primaryColor} 0%, ${primaryColor} ${value * 100}%, #E5E7EB ${value * 100}%, #E5E7EB 100%)`,
            WebkitAppearance: 'none',
            appearance: 'none'
          }}
        />
      </div>
    </div>
  )
}

export default Slider
